import "stream-chat-react/dist/css/v2/index.css";
import tw from "twin.macro";
import type { CSS } from ".";

const streamChatCustomStyles: CSS = {
  ".carousel-root": {
    ".carousel": {
      ".slide": {
        ".str-chat__modal-image__wrapper": {
          alignItems: "center",
          display: "flex",
          height: "100% !important",
          justifyContent: "center",
        },
        img: {
          width: "auto !important",
        },
      },
      ".slider-wrapper": {
        height: "100% !important",
        "ul.slider": {
          height: "100% !important",
        },
      },
      height: "100% !important",
    },
    height: "100% !important",
  },
  ".str-chat": {
    // Hide connection error notifications
    ".str-chat__connection-status": {
      display: "none !important",
    },

    // Hide connection failure banner
    ".str-chat__container": {
      ".str-chat__input-flat": {
        ".rfu-dropzone > div[role='button']": {
          display: "none !important",
        },

        ".rfu-dropzone > p": {
          display: "none !important",
        },

        // Hide SVG and text elements specifically within dropzone only
        ".rfu-dropzone > svg": {
          display: "none !important",
        },

        ".rfu-dropzone__icon": {
          display: "none !important",
        },

        // Hide the inner dropzone content
        ".rfu-dropzone__inner": {
          display: "none !important",
        },

        // Hide only the visual elements of ImageDropzone but keep functionality
        ".rfu-dropzone__overlay": {
          display: "none !important",
        },

        ".rfu-dropzone__text": {
          display: "none !important",
        },
        // Remove all visual effects from buttons
        ".str-chat__input-flat-fileupload": {
          background: "transparent !important",
          border: "none !important",
          borderRadius: "0 !important",
          boxShadow: "none !important",
          filter: "none !important",
          height: "28px !important",
          margin: "0 !important",
          minHeight: "28px !important",
          minWidth: "28px !important",
          outline: "none !important",
          padding: "2px !important",
          transform: "none !important",
          width: "28px !important",
        },
        // Ensure icon container is also transparent
        ".str-chat__input-flat-fileupload [role='img']": {
          background: "transparent !important",
          border: "none !important",
          boxShadow: "none !important",
          filter: "none !important",
          height: "auto !important",
          margin: "0 !important",
          minHeight: "auto !important",
          minWidth: "auto !important",
          outline: "none !important",
          padding: "0 !important",
          transform: "none !important",
          width: "auto !important",
        },

        ".str-chat__input-flat-fileupload:focus": {
          background: "transparent !important",
          boxShadow: "none !important",
          outline: "none !important",
        },

        ".str-chat__input-flat-fileupload:hover": {
          background: "transparent !important",
          boxShadow: "none !important",
          transform: "none !important",
        },

        ".str-chat__textarea": {
          position: "relative",
        },

        ".str-chat__textarea>textarea": {
          ...tw`
                text-base
                shadow-sm
                focus:(ring-blue-400 border-blue-400)
                block
                w-full
                rounded-md`,
          background: "$white",
          border: "1px solid $gray300",
          minHeight: "auto !important",
          padding: "$xsmall $small",
          paddingRight: "90px !important", // Increased space for larger buttons
        },

        // Remove any tooltip container styling that might affect buttons
        ".str-chat__tooltip": {
          background: "transparent !important",
          border: "none !important",
          boxShadow: "none !important",
          filter: "none !important",
          margin: "0 !important",
          outline: "none !important",
          padding: "0 !important",
          transform: "none !important",
        },

        padding: "0 !important",
      },
      ".str-chat__list": {
        ".str-chat__reverse-infinite-scroll": {
          paddingTop: "0px !important",
        },
        paddingLeft: "$small",
      },
      flexDirection: "column !important",
    },

    ".str-chat__date-separator": {
      padding: "$small !important",
    },

    ".str-chat__emojisearch__item": {
      ".str-chat__emoji-item--entity": {
        fontSize: "1.4rem !important",
        marginRight: "0.75rem !important",
      },

      ".str-chat__emoji-item--name > span": {
        fontSize: "1rem !important",
      },
    },

    ".str-chat__message--me": {
      ".str-chat__message-text": {
        backgroundColor: "#60A5FA !important",
        border: "1px solid #60A5FA !important",
        borderBottomLeftRadius: "30px !important",
        borderBottomRightRadius: "0 !important",
        borderTopLeftRadius: "30px !important",
        borderTopRightRadius: "30px !important",
      },
    },

    ".str-chat__message-attachment-card--content": {
      backgroundColor: "$white !important",
    },

    ".str-chat__message-attachment-card--title": {
      color: "$blue400",
    },

    ".str-chat__message:not(.str-chat__message--me)": {
      ".str-chat__message-text": {
        backgroundColor: "$neutral200 !important",
        borderBottomLeftRadius: "0 !important",
        borderBottomRightRadius: "30px !important",
        borderTopLeftRadius: "30px !important",
        borderTopRightRadius: "30px !important",
      },
    },

    ".str-chat__notification": {
      display: "none !important",
    },
    // Hide any other connection-related notifications
    "[data-testid='connection-status']": {
      display: "none !important",
    },
    height: "100% !important",
  },

  ".str-chat__attachment-list-scroll-container": {
    display: "flex !important",
    gap: "4px",
    overflow: "visible !important",
  },
  // ---------- Custom overrides for attachment preview list ----------
  ".str-chat__attachment-preview-list": {
    display: "flex !important",
    gap: "4px",
  },

  // ------------------------------------------------------------------
  ".str-chat__attachment-preview-list .rfu-dropzone": {
    display: "flex !important",
  },

  ".str-chat__attachment-preview-list .rfu-dropzone > div[role='button']": {
    display: "flex !important",
  },

  ".str-chat__attachment-preview-list .rfu-dropzone > svg": {
    display: "block !important",
  },

  ".str-chat__attachment-preview-list .rfu-dropzone__inner": {
    display: "flex !important",
  },
  ".str-chat__attachment-preview-list .rfu-image-upload-button": {
    alignItems: "center",
    display: "flex !important",
    flex: "0 0 96px",
    height: 96,
    justifyContent: "center",
    minWidth: 96,
    width: 96,
  },
  ".str-chat__attachment-preview-list .rfu-thumbnail-placeholder": {
    display: "flex !important",
    height: "60px",
    width: "60px",
  },

  ".str-chat__message--me .str-chat__message-text-inner *, .str-chat__message--me .str-chat__message-simple-text-inner *":
    {
      color: "$white !important",
    },

  ".str-chat__message--me .str-chat__message-text-inner div, .str-chat__message--me .str-chat__message-simple-text-inner div":
    {
      color: "$white !important",
    },

  ".str-chat__message--me .str-chat__message-text-inner p, .str-chat__message--me .str-chat__message-simple-text-inner p":
    {
      color: "$white !important",
    },

  // Force white text in user message bubbles
  ".str-chat__message--me .str-chat__message-text-inner, .str-chat__message--me .str-chat__message-simple-text-inner":
    {
      backgroundColor: "transparent !important",
      color: "$white !important",
    },
  // Mobile-specific styles for better button ordering and spacing
  "@media (max-width: 768px)": {
    ".str-chat__container .str-chat__input-flat": {
      marginTop: "4px !important",
    },
    ".str-chat__container .str-chat__input-flat .str-chat__input-flat--textarea-wrapper":
      {
        flex: "1 !important",
        width: "100% !important",
      },
    ".str-chat__container .str-chat__input-flat .str-chat__input-flat-wrapper":
      {
        alignItems: "flex-end !important",
        display: "flex !important",
        flex: "1 !important",
        width: "100% !important",
      },
    ".str-chat__container .str-chat__input-flat .str-chat__textarea": {
      alignItems: "flex-end !important",
      display: "flex !important",
      position: "relative !important",
    },
    ".str-chat__container .str-chat__input-flat .str-chat__textarea > div:not(.rta)":
      {
        bottom: "4px !important",
        right: "8px !important",
      },
    ".str-chat__container .str-chat__input-flat .str-chat__textarea>textarea": {
      paddingRight: "96px !important",
    },
    ".str-chat__container .str-chat__input-flat--send-button-active": {
      marginTop: "4px !important",
    },
  },
};

export { streamChatCustomStyles };
